import { Flex, Box } from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import Messages from "../../components/Chat/messages";
import Footer from "../../components/Chat/footer";
import Sidebar from "../../components/Chat/sidebar";
import ExpertDataService from "../../services/Expert";
import { BlankChat } from "../../components/Chat/BlankChat";
import { appContext } from "../../Context/AppContext";

const Chat = () => {
  const [messages, setMessages] = useState([]);
  const [id, setId] = useState<any>(null);
  const [inputMessage, setInputMessage] = useState("");
  const { chatId, setChatId } = useContext(appContext);

  const handleUser = (id: string) => {
    setChatId(id);
  };

  const handleSendMessage = () => {
    if (!inputMessage.trim().length) {
      return;
    }
    const data = {
      userId: chatId,
      text: inputMessage,
    };
    ExpertDataService.sendMessage(data)
      .then((res) => {
        fetchMessageHistory();
        setInputMessage("");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const fetchMessageHistory = () => {
    ExpertDataService.getMessageHistory(chatId)
      .then((res) => {
        setMessages(res.data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (chatId !== null) {
      fetchMessageHistory();

      const intervalId = setInterval(() => {
        fetchMessageHistory();
      }, 3000);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [chatId]);

  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">Manoshala Care - Chat</div>
        <div className="">
          <Flex w="100%" h="80vh" flexDir={{ base: "column", md: "row" }}>
            <Sidebar func={handleUser} />
            <Flex
              w={{ base: "100%", md: "80%" }}
              h={{ base: "calc(100vh - 65px)", md: "90%" }}
              mt={{ base: 0, md: 65 }}
              ml={{ base: 0, md: 280 }}
              placeItems="end"
              flexDir="column"
            >
              {chatId !== null ? (
                <Messages messages={messages} />
              ) : (
                <BlankChat />
              )}
              {chatId !== null && (
                <Footer
                  inputMessage={inputMessage}
                  setInputMessage={setInputMessage}
                  handleSendMessage={handleSendMessage}
                />
              )}
            </Flex>
          </Flex>
        </div>
      </div>
    </>
  );
};

export default Chat;
